import { useMemo } from "react";
import Switch from "@mui/material/Switch";
import DataTable from "../_Components/DataTable";
import ApiPromocategoryagent from "../../../core/api/api.promocategoryAgent";
import SwalMessage from "../_Components/SwalMessage";
import _ from "lodash";

function DataGridPromoCategoryAgent(props) {
  // const [checkBoxList, setCheckBoxList] = useState([]);

  // useEffect(() => {
  //   props.setCheckBoxList2(checkBoxList);
  // }, [checkBoxList]);

  // const handleSelect = (id, node) => {
  //   const data = {
  //     id: node.id,
  //     promoCategoryCommisionId: node.promoCategoryCommisionId,
  //     promoCategoryId: node.promoCategoryId,
  //   };
  //   checkBoxList.some((item) => data.id == item.id)
  //     ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item.id != data.id))
  //     : !_.isEmpty(checkBoxList)
  //       ? checkBoxList.some(
  //           (item) =>
  //             data.promoCategoryCommisionId == item.promoCategoryCommisionId &&
  //             data.promoCategoryId == item.promoCategoryId,
  //         )
  //         ? setCheckBoxList((checkBoxList) => [...checkBoxList, data])
  //         : SwalMessage({ title: "جهت انتخاب گروهی ،گروه تخفیف و کمیسیون باید یکسان باشند", iSsuccess: false })
  //       : setCheckBoxList((checkBoxList) => [...checkBoxList, data]);
  // };

  const handleChange = (name) => (event) => {
    callApiService(name, 0);
  };
  async function callApiService(rowItem) {
    let PromoCategoryAgentList = [];
    PromoCategoryAgentList.push(rowItem.id);
    ApiPromocategoryagent.removePromoCategoryAgent({
      Id: PromoCategoryAgentList,
      IsActive: !rowItem.isActive,
    }).then((result) => {
      SwalMessage({ title: result.message, iSsuccess: result.data });
      if (result.succeeded == true) document.getElementById("submitButton").click();
    });

    // const response = await ApiPromocategoryagent.updatePromoCategoryAgentStatus({
    //     id: item.id,
    //      isActive: !item.isActive  ,

    //     });

    // SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(() => [
    // {
    //   accessor: "#",
    //   Header: "انتخاب",
    //   minWidth: 15,
    //   Cell: ({ row }) => (
    //     <div
    //       onClick={() => handleSelect(row.original.id, row.original)}
    //       style={{
    //         pointerevents: "none",
    //         opacity: 0.7,
    //       }}
    //     >
    //       {" "}
    //       <input
    //         type="checkbox"
    //         className="ml-6 pl-6 my-1 "
    //         checked={!_.isEmpty(checkBoxList) ? checkBoxList.some((item) => row.original.id == item.id) : false}
    //       />{" "}
    //     </div>
    //   ),
    // },
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "agentS",
      Header: "نام نماینده",
      minWidth: "100px",
    },
    {
      accessor: "promoCategoryCommisionS",
      Header: "نام گروه کمیسیون",
      minWidth: "100px",
    },
    {
      accessor: "promoCategoryS",
      Header: "نام گروه تخفیف",
      minWidth: "100px",
    },
    {
      Header: "وضعیت گروه",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isActive}
            //checked={state.checkedA}
            value="row.original.isActive"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    // {
    //   Header: "عملیات",
    //   accessor: "",
    //   minWidth: 150,
    //   align: "center",
    //   Cell: ({ row }) => (
    //     <div className="text-center">
    //       {checkBoxList.some((item) => item.id == row.original.id) ? (
    //         <Link
    //           title="ویرایش"
    //           className="btn btn-light-primary btn-sm mr-2 btn-icon"
    //           key={0}
    //           to={{
    //             pathname: `/promoCategoryAgent/${row.original.id}`,
    //             state: {
    //               neWPromoCategoryAgent: true,
    //               AgentId: row.original.id,
    //               data: checkBoxList,
    //             },
    //           }}
    //         >
    //           <i className="far fa-edit text-small"></i>
    //         </Link>
    //       ) : (
    //         <Link
    //           className="btn btn-light-primary btn-sm mr-2 btn-icon"
    //           title="ویرایش"
    //           key={0}
    //           to={{
    //             pathname: `/promoCategoryAgent/${row.original.id}`,
    //             state: {
    //               neWPromoCategoryAgent: true,
    //               AgentId: row.original.id,
    //             },
    //           }}
    //         >
    //           <i className="far fa-edit text-small"></i>
    //         </Link>
    //       )}
    //     </div>
    //   ),
    // },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={props.data} />
    </div>
  );
}

export default DataGridPromoCategoryAgent;
